import * as React from 'react';
import { ActionPlanRiskConsequence, ActionPlanRiskLikelihood } from '../../amorg-common';
import { SegmentBar } from './SegmentBar';
import { riskAssessment } from '../../utils/riskAssessment';
import { Flex } from '../compositeComponents/FlexHelpers';
import { colors } from '../colors/color';
import { Label } from '../Label';
import { Small } from '../typography/Body';
import { txt } from '../../txt';
import { DetailedRiskAssessmentModalButton } from '../../pages/actionplans/components/DetailedRiskAssessmentModalButton';
import { DialGauge } from './DialGauge';

type RiskAssessmentEvaluator2Props = {
    consequence: ActionPlanRiskConsequence,
    likelihood: ActionPlanRiskLikelihood,
    onChange: (consequence: ActionPlanRiskConsequence, likelihood: ActionPlanRiskLikelihood) => void;
};
export function RiskAssessmentEvaluator2 (props: RiskAssessmentEvaluator2Props): JSX.Element
{

    const risk = riskAssessment.calculateRisk(props.consequence, props.likelihood);

    //const segmentColor = colors.graphs.segmentBar.selected;
    const segmentColor = colors.graphs.segmentBar.selectedNeutral;
    const riskColor = colors.riskCategory(risk);

    return (
        <Flex flexDirection="column" grow='1'>
            <Flex justifyContent='center' alignItems='center' gap={4}>
                <Label style={{alignSelf:'center'}}>Risikovurdering</Label>
                <DetailedRiskAssessmentModalButton
                    consequence={props.consequence}
                    likelihood={props.likelihood}
                    onUpdate={(consequence, likelihood) => props.onChange(consequence, likelihood)} />
            </Flex>

            <Flex gap={16}>
                <Flex flexDirection="column" justifyContent='flex-end' alignItems='center' gap={8} style={{width: '110px'}}>
                        <DialGauge
                            segments={4}
                            selectedSegments={riskAssessment.getRiskIndex(risk) + 1}
                            color={riskColor}
                            widthPx={80}
                        />
                        <Small>{risk}</Small>
                </Flex>

                <div style={{ flexGrow: 1, display: 'flex', flexDirection: 'column', gap: '2px'}}>


                    <Flex flexDirection="column">
                        <Small>{txt.riskAssessment.likelihood(props.likelihood)}</Small>
                        <SegmentBar totalSegments={4} height={16} segments={[
                            {
                                color: riskAssessment.getLikelihoodIndex(props.likelihood) >= 0 ? segmentColor : colors.graphs.segmentBar.unselected,
                                onClick: () => props.onChange(props.consequence, '1 - unlikely'),
                                toolTip: <span>{txt.riskAssessment.likelihood('1 - unlikely')}</span>
                            },

                            {
                                color: riskAssessment.getLikelihoodIndex(props.likelihood) >= 1 ? segmentColor : colors.graphs.segmentBar.unselected,
                                onClick: () => props.onChange(props.consequence, '2 - rare'),
                                toolTip: <span>{txt.riskAssessment.likelihood('2 - rare')}</span>
                            },

                            {
                                color: riskAssessment.getLikelihoodIndex(props.likelihood) >= 2 ? segmentColor : colors.graphs.segmentBar.unselected,
                                onClick: () => props.onChange(props.consequence, '3 - possible'),
                                toolTip: <span>{txt.riskAssessment.likelihood('3 - possible')}</span>
                            },
                            {
                                color: riskAssessment.getLikelihoodIndex(props.likelihood) >= 3 ? segmentColor : colors.graphs.segmentBar.unselected,
                                onClick: () => props.onChange(props.consequence, '4 - likely'),
                                toolTip: <span>{txt.riskAssessment.likelihood('4 - likely')}</span>
                            }]} 
                        />
                    </Flex>

                    <Flex flexDirection="column">
                        <Small>{txt.riskAssessment.consequence(props.consequence)}</Small>
                        <SegmentBar totalSegments={4} height={16} segments={[
                            {
                                color: riskAssessment.getConsequenceIndex(props.consequence) >= 0 ? segmentColor : colors.graphs.segmentBar.unselected,
                                onClick: () => props.onChange('1 - small', props.likelihood),
                                toolTip: <span>{txt.riskAssessment.consequence('1 - small')}</span>
                            },

                            {
                                color: riskAssessment.getConsequenceIndex(props.consequence) >= 1 ? segmentColor : colors.graphs.segmentBar.unselected,
                                onClick: () => props.onChange('2 - significant', props.likelihood),
                                toolTip: <span>{txt.riskAssessment.consequence('2 - significant')}</span>
                            },

                            {
                                color: riskAssessment.getConsequenceIndex(props.consequence) >= 2 ? segmentColor : colors.graphs.segmentBar.unselected,
                                onClick: () => props.onChange('3 - severe', props.likelihood),
                                toolTip: <span>{txt.riskAssessment.consequence('3 - severe')}</span>
                            },
                            {
                                color: riskAssessment.getConsequenceIndex(props.consequence) >= 3 ? segmentColor : colors.graphs.segmentBar.unselected,
                                onClick: () => props.onChange('4 - catastrophic', props.likelihood),
                                toolTip: <span>{txt.riskAssessment.consequence('4 - catastrophic')}</span>
                            }]}
                        />
                    </Flex>
                </div>
            </Flex>
        </Flex>
    );
}